<template>
  <div id="LocationSupportView" class="location-viwe-layout">
    <v-row
      ><v-col cols="12">
        <v-card outlined>
          <v-card-title>{{ $t("vendor.headerStep3") }}</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="showTable"
              :loading="loadingProject"
              loading-text="Loading... Please wait"
            ></v-data-table></v-card-text></v-card></v-col
    ></v-row>
  </div>
</template>

<script>
import { vendorservice } from "../../services/vendorservice";

export default {
  name: "LocationSupportView",
  data: () => ({
    showTable: [],
    headers: [
      { text: "Country", value: "countryName" },
      { text: "Province", value: "provinceName" },
    ],
    loadingProject: false,
    vendorLocationList: [],
  }),
  watch: {
    propVendorLocationList(value) {
      if (value) this.showTable = this.newData(value);
    },
  },
  async mounted() {
    await this.getLocation();
  },
  methods: {
    async getLocation() {
      this.loadingProject = true;
      this.vendorLocationList = await vendorservice.GetVendorLocation(
        this.$store.state.AppActiveUser.userName,
        this.$store.state.AppActiveUser.vendorID
      );
      this.showTable = await this.newData(this.vendorLocationList);
      this.loadingProject = false;
    },
    newData(data) {
      let result = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isActive) {
          const element = {
            ...data[i],
          };
          result.push(element);
        }
      }

      return result;
    },
  },
};
</script>
